import { isArray, isNull, isUndefined } from "../../util/TypeUtil";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";
import EMailBaseContent from "./EMailBaseContent";
import MCBlock from "./MCBlock";


/**
 * DraftEmailContent.js
 * 
 * Created on Nov 7, 2013, 10:15:16 AM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class DraftEmailContent extends EMailBaseContent {

    constructor(languagePack, contentID, id, sender, recipients, ccs, bccs, subject, contentBlocks, dateTimeOffset, priority, attachments, sent) {        
        super(languagePack, contentID, DraftEmailContent.NAME, DraftEmailContent.TYPE, id, sender, recipients, ccs, subject, dateTimeOffset, priority, attachments);        
        this._bccsIDs = [];
        this._contentBlocks = [];
        this._sent = !isUndefined(sent) ? sent : false;

        if (isArray(bccs)) {
            for (var i = 0; i < bccs.length; i++) {
                const aBcc = bccs[i];
                this.addBCC(aBcc);
            }
        }

        if (isArray(contentBlocks)) {
            for (var i = 0; i < bccs.length; i++) {
                const contentBlock = contentBlocks[i];
                this._contentBlocks.add(contentBlock);
            }
        }
    }

    /*
     * @return {Map}
     */
    getVariables() {
        const variables = new Map();

        for (var i = 0; i < this._contentBlocks.length; i++) {
            const contentBlock = this._contentBlocks[i];
            if (contentBlock instanceof MCBlock) {
                const selectedOption = contentBlock.getSelectedOption();
                if (!isNull(selectedOption)) {
                    const mcOptions = contentBlock.getOptions();
                    for (var j = 0; j < mcOptions.length; j++) {
                        const mcOption = mcOptions[j];
                        if (!isNull(mcOption.getVariable()) && mcOption.getVariable() !== "") {
                            variables.set(mcOption.getVariable(), mcOption === selectedOption);
                        }
                    }
                }
            }
        }
        return variables;
    }

    getSent() {
        return this._sent;
    }

    setSent(value) {
        this._sent = value;
    }

    getRecipients() {
        return this._recipients;
    }

    setRecipients(value) {
        this._recipients = value;
    }

    //_recipients

    /*
     * @return {Array}
     */
    getScores() {
        const scores = [];
        for (var i = 0; i < this._contentBlocks.length; i++) {
            const contentBlock = this._contentBlocks[i];
            if (contentBlock instanceof MCBlock) {
                const selectedOption = contentBlock.getSelectedOption();
                if (!isNull(selectedOption)) {
                    scores.concat(selectedOption.getScores());
                }
            }
        }
        return scores;
    }

    remove() {
        for (var i = 0; i < this._contentBlocks.length; i++) {
            this._contentBlocks[i].remove();
        }
        this.contentBlocks = [];
        this.removeAllBCCs();
        this.remove();
    }

    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------


    //----------------------------------
    //  contentBlocks
    //----------------------------------

    /*
     * @return {Array}
     */
    getContentBlocks() {
        return this._contentBlocks;
    }

    addContentBlock(content) {
        this._contentBlocks.push(content);
    }

    removeContentBlock(content) {
        this._contentBlocks.remove(content);
    }

    setContentPosition(content, index) {
        // TODO: implement
    }

    getBccs() {
        const bccs = [];
        for (const bccID in this._bccsIDs) {
            bccs.push(this.getLanguagePackText(bccID));
        }
        return bccs;
    }

    addBCC(value) {
        const id = `bcc${Math.random() * Number.MAX_VALUE}`;
        this.setLanguagePackText(id, value);
    }

    removeBCC(value) {
        for (const bccID in this._bccsIDs) {
            if (this.getLanguagePackText(bccID) === value) {
                this.removeLanguagePackText(bccID);
                this._bccsIDs.remove(bccID);
            }
        }
    }

    removeAllBCCs() {
        for (const bccID in this._bccsIDs) {
            this.removeLanguagePackText(bccID);
            this._bccsIDs.remove(bccID);
        }
        this._bccsIDs = [];
    }

    //--------------------------------------------------------------------------
    //
    //  Public functions
    //
    //--------------------------------------------------------------------------       

    setPropertiesFromObject(object) {
        if (!isNull(object.bccIDs)) {
            this._bccsIDs = object.bccIDs;
            delete object.bccIDs;
        }

        this._sent = (isNull(object.sent)) ? false : object.sent;
        delete object.sent;

        if (!isNull(object.contentBlocks) && isArray(object.contentBlocks)) {
            for (let i = 0; i < object.contentBlocks.length; i++) {
                this._contentBlocks[i] = ContentFactory.getContentFromObject(object.contentBlocks[i], this._languagePack);
            }
            delete object.contentBlocks;
        }
        super.setPropertiesFromObject(object);
    }

    convertToObject() {
        const object = super.convertToObject();
        object.bccIDs = this._bccsIDs;
        object.sent = this._sent;

        //Export content blocks
        object.contentBlocks = [];
        for (let i = 0; i < this._contentBlocks.length; i++) {
            object.contentBlocks[i] = this._contentBlocks[i].convertToObject();
        }
        return object;
    }

    exportText(cvs) {
        console.warn("[EMailBaseContent]", "the method exportText is not yet implemented!");
    }
}

DraftEmailContent.NAME = "Draft Email";
DraftEmailContent.TYPE = ContentTypes.TYPE_EMAIL_DRAFT;
